import { Link } from 'react-router-dom';

const SupportDashboard = () => {
	return (
		<div>
			For contact go to{' '}
			<Link
				to="https://haggles.ai/contact/"
				target="_blank"
				rel="noopener noreferrer"
				className="text-blue-500 hover:text-blue-700"
			>
				https://haggles.ai/contact/
			</Link>
		</div>
	);
};
export default SupportDashboard;
